<template>
  <div v-if="quizGroups.length > 0" class="vx-row">
    <div class="vx-col w-full mb-base" v-for="(group, index) in quizGroups" :key="index"
         :class="{'md:w-1/2' : quizGroups.length - 1 !== index || index % 2 !== 0}">
      <vx-card class="mb-4" :title="`النموذج ${String.fromCharCode(index + 65)}`" no-shadow card-border collapse-action>
        <div class="flex mb-4">
          <div class="text-center lg:w-1/5 w-full">
            <p class="text-gray">مجموع الأسئلة</p>
            <p class="text-xl font-bold">{{group.questions.length}}</p>
          </div>
          <div class="text-center lg:w-1/5 w-full">
            <p class="text-gray">مجموع الدرجات</p>
            <p class="text-xl font-bold">{{calcTotalMarks(group.questions)}}</p>
          </div>
        </div>
        <question-item class="mt-2" v-for="(question, index) in group.questions"
                       :key="question.id"
                       :data="question"
                       :edit-only="quizHasStarted"
                       @save="save(...arguments, group, index)"
                       @remove="removeQuestion(...arguments, group, index)"/>
        <div v-if="!quizHasStarted" class="flex flex-wrap">
          <vs-button @click="addQuestion(group)" class="rounded-full mt-4 mr-0 lg:mr-2 lg:w-auto w-full" color="success" icon="icon-plus" icon-pack="feather" icon-after>إضافة سؤال</vs-button>
          <vs-button @click="openUploadQuestionsForm(group)" class="rounded-full mt-4 lg:w-auto w-full">إضافة سؤال من بنك الأسئلة</vs-button>
        </div>
      </vx-card>
    </div>
    <upload-questions ref="uploadQuestions" v-if="!quizHasStarted" @selectedQuestions="importQuestions" :active.sync="isUploadQuestionsActive" />
  </div>
</template>

<script>
    import QuestionItem from '@/views/questionBanks/QuestionItem'
    import questionsAPI from '@/api/questionsAPI'
    import UploadQuestions from '@/views/course/quizzes/UploadQuestions'

    export default {
        name: "QuizQuestions.vue",
        components: { UploadQuestions, QuestionItem },
        props: {
            quizGroups: {
                type: Array,
                default: () => []
            },
            quizHasStarted: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                isUploadQuestionsActive: false,
                uploadToGroup: null,
            }
        },
        methods: {
            openUploadQuestionsForm(group){
                this.isUploadQuestionsActive = true
                this.uploadToGroup = group
            },
            importQuestions(questions){
                questions.forEach(impQuestion => {
                    let question = Object.assign({}, impQuestion, {questions_bank_id: this.uploadToGroup.questions_bank_id})
                    questionsAPI.create(question)
                        .then((response) => {
                            question.id = response.data.id
                            this.uploadToGroup.questions.push(question)
                        })
                })
            },
            calcTotalMarks(questions){
                return questions.reduce((total, question) => {
                    return total + parseInt(question.mark)
                }, 0)
            },
            addQuestion(group){
                group.questions.push({ questions_bank_id: group.questions_bank_id, answer:0, mark:1, tags:'', title:'', type:"plain" })
            },
            save(question, group, index){
                if(question.duplicated) {
                    delete question.duplicated
                    group.questions.push(question)
                } else {
                    group.questions.splice(index, 1, question)
                }
            },
            removeQuestion(question, group, index){
                if(!question.id){
                    this.$delete(group.questions, index)
                    return
                }
                let message = `هل انت متأكد حذف السؤال؟`
                this.$confirmAlert(null, message, () => {
                    questionsAPI.delete(question.id)
                        .then(response => {
                            this.$delete(group.questions, index)
                            this.$notifySuccess(response.successMessage)
                        })
                        .catch(error => this.$notifyError(error.statusMessage))
                })
            },
        },
        beforeDestroy(){
            // console.log(this.$refs.uploadQuestions)
        }
    }
</script>
